<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  components: {},
  mounted() {
  },
}
</script>

<style>
:root {
  --main-color: #007bff;
  --main-color-1: #3296ff;
}

body,
html {
  width: calc(100vw - 0px);
  height: calc(100vh - 0px);
  overflow: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  width: 100%;
  height: 100%;
}
</style>
